
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlSlug]/contests/[listingId]",
      function () {
        return require("private-next-pages/[urlSlug]/contests/[listingId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[urlSlug]/contests/[listingId]"])
      });
    }
  